import { MapMarkedAltIcon, ListIcon, ThIcon } from 'src/components/common/icons'

export const dutyContactDeviceFields = {
  PHONE: 'phone',
  CELLPHONE: 'cellphone',
  PERSONAL_PHONE: 'personalPhone',
  PERSONAL_CELLPHONE: 'personalCellphone',
}

export const dutyContactDeviceI18n = {
  PHONE: 'WEB_PROFESSIONAL',
  CELLPHONE: 'WEB_PROFESSIONAL_CELLPHONE',
  PERSONAL_PHONE: 'WEB_PERSONAL',
  PERSONAL_CELLPHONE: 'WEB_PERSONAL_CELLPHONE',
}

export const userStatusI18n = {
  ACTIVE: 'WEB_ACTIVE_USER',
  EXPIRED: 'WEB_EXPIRED_USER',
  SUSPENDED: 'WEB_SUSPENDED_USER',
  LOCKED: 'WEB_LOCKED_USER',
}

export const userRolesI18n = {
  MAIN_MANAGER: 'WEB_MAIN_MANAGER',
  QUALITY_AGENT: 'WEB_QUALITY_AGENT',
  DATABASE_MANAGER: 'WEB_DATABASE_MANAGER',
  ACQUISITION_MANAGER: 'WEB_ACQUISITION_MANAGER',
}

export const accessLevelsI18n = {
  MAIN_ADMIN: 'WEB_MAIN_ADMIN',
  SECONDARY_ADMIN: 'WEB_SECONDARY_ADMIN',
  USER: 'WEB_USER',
}

export const displayModes = {
  PLAN: { i18n: 'WEB_PLAN_MODE', icon: MapMarkedAltIcon },
  BLOCK: { i18n: 'WEB_BLOCK_MODE', icon: ThIcon },
  LIST: { i18n: 'WEB_LIST_MODE', icon: ListIcon },
}
